import React from "react";

export function ImageSlide(props) {
  let { slide, height, width } = props;

  return <img src={slide.image_path} height={height} width={width} alt="" />;
}
